const assetDetailsTabsStyles = {
  tab: 'w-full max-md:w-full py-0 px-0 gap-2',
};

export { assetDetailsTabsStyles };
